import ListService from '@isceco/widget-library2/basic-elements/List/ListService.js';
import BerechtigungUtil from './BerechtigungUtil'

export default class BerechtigteListService extends ListService {
  getOptions() {
    const options = super.getOptions()
    const activeProfile = new BerechtigungUtil().getActiveProfile()
    if (activeProfile) {
      options.headers["X-Profile"] = activeProfile.uuid
    }
    return options
  }
}
